'use client'

import type { ArbitrageOpportunity } from '@/features/opportunities/types'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { Typography } from '@/ui/atoms/typography/Typography'

interface OpportunitiesCardContentProps {
  topOpportunity: ArbitrageOpportunity | undefined
  totalCount: number
  isLoading: boolean
}

export function OpportunitiesCardSkeleton() {
  return (
    <div className="flex gap-4">
      <Skeleton className="h-6 w-20" />
      <Skeleton className="h-6 w-16" />
    </div>
  )
}

export function OpportunitiesCardContent({ topOpportunity, totalCount, isLoading }: OpportunitiesCardContentProps) {
  if (isLoading) {
    return <OpportunitiesCardSkeleton />
  }

  if (!topOpportunity) {
    return <span className="text-muted-foreground text-sm">No opportunities available</span>
  }

  return (
    <div className="flex flex-wrap gap-8">
      <div className="flex flex-col">
        <Typography variant="span" gradient className="font-semibold text-xl" style={{ paddingBottom: '0' }}>
          {topOpportunity.spread.toFixed(2)}%
        </Typography>
        <span className="text-[11px] text-muted-foreground">Best Spread</span>
      </div>
      <div className="flex flex-col">
        <span className="font-semibold text-white text-xl">{totalCount}</span>
        <span className="text-[11px] text-muted-foreground">Opportunities</span>
      </div>
    </div>
  )
}
